module.exports = __webpack_public_path__ + "static/media/imprimir.551a01d1.png";